import React from 'react';
import { BarChart, CartesianGrid, XAxis, YAxis, Tooltip, Bar } from 'recharts';
import { observer } from 'mobx-react-lite';

import find from 'lodash/find';
import ObservableAutoSizer from '@vromo/ui/components/ObservableAutoSizer';

const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

interface Props {
    jobsByDayOfWeek: {
        key: number;
        value: number;
    }[];
}

export default observer<Props>(function DayOfWeekJobChart({ jobsByDayOfWeek }) {
    const data = days.map((d) => {
        const result = { name: d, value: 0 };

        const jobsCompleted = find(jobsByDayOfWeek, (j) => days[j.key] == d);

        result.value = jobsCompleted ? jobsCompleted.value : 0;

        return result;
    });

    return (
        <ObservableAutoSizer customChildren={({ width }: { width: number }) => (
            <BarChart
                width={width}
                height={220}
                data={data}
                margin={{
                    top: 5,
                    right: 30,
                    bottom: 5
                }}>
                <CartesianGrid strokeDasharray="3 4" />
                <XAxis dataKey="name" tickFormatter={(t) => t.slice(0, 3)} />
                <YAxis allowDecimals={false} />
                <Tooltip formatter={(value: number) => [value, 'Jobs Completed']} />
                <Bar dataKey="value" fill="#EE6352" />
                <Tooltip />
            </BarChart>
        )} />
    );
});
